import { useI18n } from 'context/I18nProvider'
import * as React from 'react'
import type { SelectInstance } from 'react-select'
import Select from 'react-select'
import type { BaseSelectProps, Value } from './SelectComponents'
import { BaseSelect } from './SelectComponents'

interface Props extends BaseSelectProps {
  selectAll?: boolean
  selectAllValue?: string
  isLoading?: boolean
  isSearchable?: boolean
}

const CustomSelect = (props: Props) => {
  const { i18n } = useI18n()
  const selectRef = React.useRef<SelectInstance>(null)
  const { selectAll, selectAllValue = '', options = [], value, onChange = () => {}, ...newProps } = props
  const [selectedOptions, setSelectedOptions] = React.useState<Value | Value[]>(props?.value)

  const optionsWithSelectAll = React.useMemo(
    () => [...(selectAll ? [{ value: selectAllValue, label: i18n('select_all') }] : []), ...options],
    [i18n, options, selectAll, selectAllValue],
  )

  const handleChange = (selected: Value | Value[]) => {
    // If it's a not an empty array
    if (Array.isArray(selected) && selected.length) {
      // If multi and selectAll is selected
      if (props.isMulti && selected.some(option => option.value === selectAllValue)) {
        setSelectedOptions(options)
        onChange(options)
        selectRef.current?.blur()
      } else {
        setSelectedOptions(selected)
        onChange(selected)
      }
    } else {
      setSelectedOptions(selected)
      onChange(selected)
    }
  }

  React.useEffect(() => {
    setSelectedOptions(value as Value | Value[])
  }, [value])

  return (
    <BaseSelect
      ref={selectRef}
      component={Select}
      options={optionsWithSelectAll}
      value={selectedOptions || value}
      onChange={handleChange}
      {...newProps}
    />
  )
}

export default CustomSelect
